module.exports = __webpack_public_path__ + "img/bateas2.8fd4c0cb.png";